import { PIXEL_FONT } from "../data/pixelFont";

const WORD = "SIDESTACK";

function PixelLetter({ char, px }: { char: string; px: number }) {
  const rows = PIXEL_FONT[char];
  if (!rows) return null;
  return (
    <div
      className="grid gap-0.5"
      style={{
        gridTemplateColumns: `repeat(5, ${px}px)`,
        gridAutoRows: `${px}px`,
      }}
    >
      {rows.flatMap((row, ri) =>
        row.split("").map((on, bi) => (
          <span
            key={`${ri}-${bi}`}
            className={
              on === "1"
                ? "bg-accent shadow-[0_0_7px_rgba(245,130,32,0.33)]"
                : ""
            }
            style={{ width: px, height: px }}
          />
        )),
      )}
    </div>
  );
}

export function PixelWordmark({ px = 14 }: { px?: number }) {
  return (
    <div
      className="flex justify-center flex-wrap"
      style={{ gap: px }}
    >
      {WORD.split("").map((ch, i) => (
        <PixelLetter key={i} char={ch} px={px} />
      ))}
    </div>
  );
}
